import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

const deleteTicketThreadByIdApi = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCall({
      url: apiConstants.TICKET.DELETE_TICKET_THREAD_BY_ID,
      method: 'delete',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}

export default deleteTicketThreadByIdApi;